// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.o9Abp{flex:1;width:100%;justify-content:inherit;min-width:0;overflow:hidden}.x2kq9{flex:1;display:flex;align-items:center;justify-content:inherit;min-width:0;overflow:hidden}.x2kq9>*{min-width:0;max-width:100%}.inWOM{flex:none;line-height:0}.QwNrN{flex:none;margin-left:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adornments": `o9Abp`,
	"value": `x2kq9`,
	"indicator": `inWOM`,
	"integrations": `QwNrN`
};
export default ___CSS_LOADER_EXPORT___;
